// generated
export const GATEWAY_VERSION = "0.25.3";
